import axios from "axios";
import { API_SERVER_URL } from "../../../resources/constants";
import { KIOSEK_ZIJE_URL } from "../url";

/**
 * Signál kioskové stránky (spec upozornění na odpojení 5.1). Záměrně samostatný axios bez interceptorů:
 * request interceptor `axiosInstance` přepíše Authorization na Bearer přihlášeného uživatele (403, hlídání stránky
 * by se nikdy nezapnulo) a odpověď 401 by spustila refresh tokenu a přesměrování na přihlášení.
 */
const kiosekZije = (deviceToken: string): Promise<void> =>
    axios.post(KIOSEK_ZIJE_URL, null, {
        baseURL: API_SERVER_URL,
        timeout: 10000,
        headers: { Authorization: `DeviceToken ${deviceToken}` },
    }).then(() => undefined);

const KiosekService = { kiosekZije };

export default KiosekService;
